//jQuery
var $ = jQuery.noConflict();
import 'jquery'; //Do not delete!!! Doesn't import jQuery, but used as placeholder.
import 'bootstrap';

import 'ekko-lightbox';
import 'ekko-lightbox/dist/ekko-lightbox.css';

import './sliders';
import Cookie from './cookie';
import Menu from './menu';

/*
 * The grid breakpoints as stated in varibles.scss
 */
const swBreakpoint = {
  xxs: 0,
  xs: 375,
  sm: 540,
  md: 768,
  lg: 1024,
  xl: 1200,
};

/*
 * Checks if is touch events are enabled 
 */
let isTouch = false;
if ('ontouchstart' in window || 'ontouch' in window) {
  isTouch = true;
  document.body.classList.add('touch');
}

/*
 * Addes the class `loaded` on document load
 */
window.addEventListener('load', () => {
  document.body.classList.add('loaded');
});

/*
 * Init Mobile Menu
 */
new Menu(
  '.header-nav',
  '.menu-toggle',
  ['open-menu'],
  swBreakpoint.md
);

/*
 * Init Cookie Banner
 */
new Cookie('.cookie-banner', true);

/*
 * Animate on entry
 */
const animateOnFirstEntryElements = document.querySelectorAll('.animate-me');
const animateOnFirstEntryObserver = new IntersectionObserver(
  function (entries) {
    entries.forEach((entry) => {
      if (
        (entry.target.dataset.ratio &&
          entry.intersectionRatio >= entry.target.dataset.ratio) ||
        (!entry.target.dataset.ratio && entry.isIntersecting)
      ) {
        entry.target.classList.add('animated');
      }
    });
  },
  {
    root: null,
    rootMargin: '0px',
    threshold: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
  }
); 

animateOnFirstEntryElements.forEach((element) => {
  animateOnFirstEntryObserver.observe(element);
});

const testDriveModalTriggers = document.querySelectorAll('[data-target="#testDriveModal"]');
const modelSelectionInput = document.getElementById('modelSelection');
if (testDriveModalTriggers.length && modelSelectionInput) {
	testDriveModalTriggers.forEach(trigger => {
		trigger.addEventListener('click', (e) => {
			modelSelectionInput.value = trigger.getAttribute("data-position");
		})
	})
}


const models = document.querySelectorAll('.models-row');
const list = document.querySelectorAll('.model-list');
const megaMenu = document.querySelectorAll('.menu-item-desktop');
const tabs = document.querySelectorAll('.section-series-model-font');

if(megaMenu){
 
  megaMenu.forEach(menuli =>{

    menuli.addEventListener("click", function( event ) {
      menuli.querySelector('.mega-menu').classList.add('d-none');
    })

    menuli.addEventListener("mouseenter", function( event ) {

    menuli.querySelector('.mega-menu ul').children.forEach((mod,index) => {
      var id = mod.children[0].getAttribute('data-serieid');
      if(index == 0){
        document.getElementById(id).classList.remove('d-none'); 
      }else{
        document.getElementById(id).classList.add('d-none');
      }
      list.forEach(model =>{
        model.addEventListener("click", function( event ) {

          var data = model.getAttribute('data-target');
          //console.log(document.querySelectorAll('["aria-controls='+ data +'"]'));
        })

        model.addEventListener("mouseenter", function( event ) {
          document.getElementById(id).classList.remove('d-none');
          list.forEach(mdl =>{
            var id2 = mdl.getAttribute('data-serieid');
            if(mdl != model){
                document.getElementById(id2).classList.add('d-none');
              }  
          })
        })
      })     
    })
  })
})

}



if(tabs){
  tabs.forEach(tab => {
    tab.addEventListener("click",function(event){
      if(this.classList.contains('active')){
        tabs.forEach(tb => {
          if(tb != tab){
            if(tb.classList.contains('active')){
              tb.classList.remove('active');
              var id2 = tb.getAttribute('aria-controls');
              document.getElementById(id2).classList.remove('active')
            }
          }
        })
      }else{
        this.classList.toggle('active'); 
        var id = this.getAttribute('aria-controls');
        document.getElementById(id).classList.toggle('active');
        tabs.forEach(tb => {
            if(tb != tab){
              if(tb.classList.contains('active')){
                tb.classList.remove('active');
              var id2 = tb.getAttribute('aria-controls');
              document.getElementById(id2).classList.remove('active');
              }              
            }
        })
      }       
    })
  })
}


/*
let counters = document.getElementsByClassName('count');


if(counters){
  counters.forEach(number =>{
    animateMe(number, 0, parseInt(number.getAttribute("data-target")), 5000);
  })
}
function animateMe(obj, initVal, lastVal, duration) {
 // console.log(lastVal)
  let startTime = null;

  //get the current timestamp and assign it to the currentTime variable
  let currentTime = Date.now();

  //pass the current timestamp to the step function
  const step = (currentTime ) => {

      //if the start time is null, assign the current time to startTime
      if (!startTime) {
            startTime = currentTime ;
      }

      //calculate the value to be used in calculating the number to be displayed
      const progress = Math.min((currentTime  - startTime) / duration, 1);

      //calculate what to be displayed using the value gotten above
     // console.log(progress * (lastVal - initVal) + initVal);
      obj.innerHTML = progress * (lastVal - initVal) + initVal;

      //checking to make sure the counter does not exceed the last value (lastVal)
      if (progress < 1) {
            window.requestAnimationFrame(step);
      }
      else{
            window.cancelAnimationFrame(window.requestAnimationFrame(step));
      }
  };

  //start animating
  window.requestAnimationFrame(step);
}

*/

var wpcf7Elm = document.querySelector( '.wpcf7-form' );

if(wpcf7Elm){
  wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {

    var inputs = event.detail.inputs; 
    var my_value = "";
    for ( var i = 0; i < inputs.length; i++) {
      if(inputs[i].name == 'position' || inputs[i].name == 'your-model'){
        my_value = inputs[i].value;
      }
    }
  
    
    if(window.location.pathname == '/epikoinonia/'){
      my_value = 'contact';
    }
  
  
    if(my_value){
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'Lead_form', 
        'model': my_value
        });
    }
  }, false );
}
 



$(document).ready(function () {

  if ( document.cookie.indexOf("ModalShown=true") < 0 ) {
    $("#infoModal").modal("show");
     var index= 0;
    $("#infoModal p img").each(function(e){
      if($(this).hasClass('aligncenter')){
        ($(this).parent()).addClass('text-center');
        index++;
      }
    })
}

$("#infoModalCookies").click(function () {
    document.cookie = "ModalShown=true; expire.setTime(today.getTime() + (60 * 60 * 1000)); path=/";
});

	$('.side-links.stage').removeClass('stage');

  $('[data-target="mega-menu-link"]').mouseover(function() {
    $(this).children('[data-target="mega-menu"]').removeClass('d-none');
  });

  $('[data-target="mega-menu-link"]').mouseout(function() {
    $('[data-target="mega-menu"]').addClass('d-none');
  });


  /*
   * Bootstrap Lightbox for WP Block Gallery
   */
  $('.wp-block-gallery').each(function (index) {
    const galleryId = 'wp-gallery-' + index;
    $(this)
      .find('a')
      .each(function () {
        let link = $(this).attr('href');
        if (
          link.endsWith('.jpg') ||
          link.endsWith('.jpeg') ||
          link.endsWith('.png')
        ) {
          this.dataset.toggle = 'lightbox';
          this.dataset.gallery = galleryId;
        }
      });
  });

  /*
   * Bootstrap Lightbox for WP Block Image
   */
  $('.wp-block-image').each(function () {
    $(this)
      .find('a')
      .each(function () {
        let link = $(this).attr('href');
        if (
          link.endsWith('.jpg') ||
          link.endsWith('.jpeg') ||
          link.endsWith('.png')
        ) {
          this.dataset.toggle = 'lightbox';
        }
      });
  });

  /*
  * Bootstrap Lightbox
  */
  $(document).on('click', '[data-toggle="lightbox"]', function (event) {
    event.preventDefault();
    $(this).ekkoLightbox({
      leftArrow:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.41 34.81"><path fill="#ffffff" d="M17.41 34.81L0 17.41 17.41 0"/></svg>',
      rightArrow:
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.41 34.81"><path fill="#ffffff" d="M0 34.81l17.41-17.4L0 0"/></svg>',
      alwaysShowClose: true,
      onShow: () => {
        document.body.classList.add('ekko-lightbox-open');
      },
      onHidden: () => {
        document.body.classList.remove('ekko-lightbox-open');
      },
    });
  });

	//   Megamune Hovers


/*	$('.model-list').hover(
		function() {
		$( this ).toggleClass( "active" )
		$("#"+$(this).attr("data-serieid")).toggleClass( "d-none" )
   }, 
	//   function () {
	// 	$(this).removeClass('hover');
	//   }
 );*/

    

    var counter = 0;
    function isIntoView(elem)
    {
        var documentViewTop = $(window).scrollTop();
        var documentViewBottom = documentViewTop + $(window).height();
        var elementTop = $(elem).offset().top;
        var elementBottom = elementTop + $(elem).height();
        return ((elementBottom <= documentViewBottom) && (elementTop >= documentViewTop));
    }
   
		$(window).scroll(function(){
      if($("#counteranim").length){
      if (isIntoView($('#counteranim'))){
         if(counter == 0){
          counter++;
          $('.count-item').each(function () {
            $(this).prop('Counter',0).animate({
              Counter: $(this).text()
            }, {
              duration: 3000,
              easing: 'swing',
              step: function (now) {
                $(this).text(Math.ceil(now).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1."));
              }
            });
            
          });
         
        }
      }
       }
   })


   

});
